import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import {
    createStrapiMediaUrl,
    ImageModel,
    useAppSelector,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import {
    fetchCompanyInformationThunk,
} from 'shared/lib';

export type HeaderState = {
    loaded: boolean
    errors: BaseError[]
    logoImage?: ImageModel
    phone?: string
    email?: string
    address?: string
    socialMedias: {
        name: string,
        image: ImageModel,
        link: string,
        showMobile?: boolean | null
    }[]
};

const initialState: HeaderState = {
    loaded: false,
    errors: [],
    socialMedias: [],
};

export const headerSlice = createSlice({
    name: 'headerSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchCompanyInformationThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.logoImage = {
                        url: createStrapiMediaUrl(response.data.data.logoImage.url),
                    };
                    state.phone = response.data.data.phone;
                    state.email = response.data.data.email;
                    state.address = response.data.data.address?.name;

                    if (response.data.data.socialMedias) {
                        state.socialMedias = response.data.data.socialMedias.map(({
                            name,
                            link,
                            image,
                            showMobile,
                        }) => ({
                            name,
                            link,
                            image: {
                                url: createStrapiMediaUrl(image?.url),
                            },
                            showMobile,

                        }));
                    }

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});

export const useHeaderState = () => useAppSelector((store) => store.header);
